import { injectStyle } from "./../../utils/style";
import { h } from "./../../utils/createElement";
import { __assign, __extends } from "tslib";
import * as React from 'react';
import { ChangeSource, MouseAction, NavSwiperTrigger, } from './interface';
import { consumeTheme } from '../../utils/theme';
injectStyle("components/Swiper/style/index.css", "[data-dui-0-122-5~=\"dui-swiper-wrapper\"]{width:770px;height:290px;border-radius:8px;font-size:24px;overflow:hidden;position:relative}[data-dui-0-122-5~=\"dui-swiper-content\"]{position:relative;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row}[data-dui-0-122-5~=\"dui-swiper-navigation\"]{-webkit-box-sizing:border-box;box-sizing:border-box;margin:0}[data-dui-0-122-5~=\"dui-swiper-navigation-dots\"]{padding:0 8px;position:absolute;left:50%;-webkit-transform:translate(-50%);transform:translate(-50%);bottom:8px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;background:rgba(0,0,0,.24);-webkit-backdrop-filter:blur(16px);backdrop-filter:blur(16px);border-radius:999px}[data-dui-0-122-5~=\"dui-swiper-navigation-item\"]{content:\"\";display:block;font-size:14px;cursor:pointer;margin-right:8px;list-style:none;float:left;width:4px;height:4px;border-radius:50%}[data-dui-0-122-5~=\"dui-swiper-navigation-item\"]:last-child{margin-right:0!important}[data-dui-0-122-5~=\"dui-swiper-navigation-arrow-left\"]{left:0;background-image:url(arrow_left_24.svg)}[data-dui-0-122-5~=\"dui-swiper-navigation-arrow-left\"],[data-dui-0-122-5~=\"dui-swiper-navigation-arrow-right\"]{background-color:hsla(0,0%,100%,.7);height:24px;width:24px;position:absolute;top:50%;background-repeat:no-repeat;background-size:cover;background-position:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);cursor:pointer}[data-dui-0-122-5~=\"dui-swiper-navigation-arrow-right\"]{right:0;background-image:url(arrow_right_24.svg)}[data-dui-0-122-5~=\"dui-swiper-page\"]{width:100%;height:100%;cursor:pointer}");
import Navigation from './Navigation';
var Swiper = (function (_super) {
    __extends(Swiper, _super);
    function Swiper(props) {
        var _this = _super.call(this, props) || this;
        _this.setAutoplayTimer = function () {
            var _a = _this.props, autoplay = _a.autoplay, interval = _a.interval, duration = _a.duration;
            var currentIndex = _this.state.currentIndex;
            _this.clearAutoplayTimer();
            if (autoplay && duration && interval && interval > 0) {
                _this.autoplayTimer = window.setTimeout(function () {
                    _this.swipeTo(currentIndex + 1, ChangeSource.AUTO);
                }, currentIndex === 0 ? interval - (duration + Swiper.EXTRA_TIME) : interval);
            }
        };
        _this.onSwiperMouseEnter = function () {
            var _a = _this.props, stopOnHover = _a.stopOnHover, showArrow = _a.showArrow, showNav = _a.showNav;
            _this.isHovering = true;
            if (stopOnHover) {
                _this.clearAutoplayTimer();
            }
            if (showArrow === 'hover') {
                _this.setState({
                    isShowArrow: true,
                });
            }
            if (showNav === 'hover') {
                _this.setState({
                    isShowNav: true,
                });
            }
        };
        _this.onSwiperMouseLeave = function () {
            var _a = _this.props, showArrow = _a.showArrow, showNav = _a.showNav;
            _this.isHovering = false;
            if (!_this.isEnd()) {
                _this.setAutoplayTimer();
            }
            if (showArrow === 'hover') {
                _this.setState({
                    isShowArrow: false,
                });
            }
            if (showNav === 'hover') {
                _this.setState({
                    isShowNav: false,
                });
            }
        };
        _this.onNavMouseHover = function (index) {
            _this.swipeTo(index, ChangeSource.HOVER);
        };
        _this.onNavMouseClick = function (index) {
            _this.swipeTo(index, ChangeSource.CLICK);
        };
        _this.onNavMouseAction = function (action, index) {
            var navTrigger = _this.props.navTrigger;
            if (action === MouseAction.CLICK && navTrigger === NavSwiperTrigger.CLICK) {
                _this.onNavMouseClick(index);
            }
            if (action === MouseAction.ENTER && navTrigger === NavSwiperTrigger.HOVER) {
                _this.onNavMouseHover(index);
            }
        };
        _this.onClickArrow = function (direction) {
            var _a = _this.state, isInAnimation = _a.isInAnimation, currentIndex = _a.currentIndex;
            if (isInAnimation) {
                return;
            }
            _this.clearAutoplayTimer();
            if (direction === 'right') {
                _this.swipeTo(currentIndex >= _this.itemLength ? 0 : currentIndex + 1, ChangeSource.CLICK);
                _this.hoverStop();
            }
            if (direction === 'left') {
                _this.swipeTo(currentIndex - 1 < -1 ? _this.itemLength - 1 : currentIndex - 1, ChangeSource.CLICK);
                _this.hoverStop();
            }
        };
        _this.themedRender = function (classNames) {
            var _a = _this.props, prefixCls = _a.prefixCls, className = _a.className, style = _a.style, children = _a.children, loop = _a.loop, duration = _a.duration;
            var _b = _this.state, currentIndex = _b.currentIndex, isInAnimation = _b.isInAnimation;
            var itemList = React.Children.toArray(children).
                map(function (item) { return item; });
            _this.itemLength = itemList.length;
            var renderItemList = _this.initRenderList(itemList, loop !== null && loop !== void 0 ? loop : true);
            _this.renderLength = renderItemList.length;
            var cls = classNames(prefixCls, className, prefixCls + "-wrapper");
            return (h("div", { className: cls, style: style, onMouseEnter: function () { return _this.onSwiperMouseEnter(); }, onMouseLeave: function () { return _this.onSwiperMouseLeave(); } },
                h("div", { className: prefixCls + "-content", style: _this.getSwipeAnimationStyle({
                        renderLength: _this.renderLength,
                        currentIndex: currentIndex,
                        needAnimation: isInAnimation,
                        duration: duration !== null && duration !== void 0 ? duration : 500,
                        hasExtraFront: loop !== null && loop !== void 0 ? loop : true,
                        animationStyle: 'ease',
                    }) }, renderItemList),
                h("div", null, _this.renderNavigation())));
        };
        _this.state = {
            isShowArrow: props.showArrow === 'always',
            isShowNav: props.showNav === 'always',
            currentIndex: 0,
            isInAnimation: false,
        };
        return _this;
    }
    Swiper.prototype.initRenderList = function (itemList, loop) {
        var res = itemList.map(function (child, index) {
            return React.cloneElement(child, __assign({ key: "swiperItem" + index }, child === null || child === void 0 ? void 0 : child.props));
        });
        var itemLength = itemList.length;
        if (itemLength > 0 && loop) {
            var firstItem = res[0];
            var lastItem = res[res.length - 1];
            res.push(React.cloneElement(firstItem, {
                key: "swiperItem" + itemLength,
            }));
            res.unshift(React.cloneElement(lastItem, {
                key: "swiperItem" + -1,
            }));
        }
        return res;
    };
    Swiper.prototype.updateCurrentIndex = function (defaultIndex) {
        if (!isNaN(defaultIndex) && defaultIndex < this.itemLength) {
            this.swipeTo(defaultIndex, ChangeSource.AUTO);
            this.setState({
                isInAnimation: false,
            });
        }
    };
    Swiper.prototype.clearAutoplayTimer = function () {
        if (this.autoplayTimer) {
            clearTimeout(this.autoplayTimer);
            this.autoplayTimer = null;
        }
    };
    Swiper.prototype.isEnd = function () {
        var loop = this.props.loop;
        var currentIndex = this.state.currentIndex;
        return !loop && currentIndex === this.itemLength - 1;
    };
    Swiper.prototype.getWrappedIndex = function (index) {
        if (index < 0) {
            return this.itemLength - 1;
        }
        if (index >= this.itemLength) {
            return 0;
        }
        return index;
    };
    Swiper.prototype.swipeTo = function (index, source) {
        this.setState({
            isInAnimation: true,
            currentIndex: index,
        });
        this.lastSource = source;
    };
    Swiper.prototype.clearAnimationTimer = function () {
        if (this.animationTimer) {
            clearTimeout(this.animationTimer);
            this.animationTimer = null;
        }
    };
    Swiper.prototype.hoverStop = function () {
        if ((!this.isHovering || !this.props.stopOnHover) && !this.isEnd()) {
            this.setAutoplayTimer();
        }
    };
    Swiper.prototype.componentDidMount = function () {
        this.updateCurrentIndex(this.props.defaultIndex);
        this.hoverStop();
    };
    Swiper.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _this = this;
        var _a;
        var currentIndex = this.state.currentIndex;
        if (prevState.currentIndex !== currentIndex) {
            this.clearAnimationTimer();
            this.hoverStop();
            if (this.isEnd()) {
                this.clearAutoplayTimer();
            }
            this.animationTimer = window.setTimeout(function () {
                var _a, _b;
                _this.setState({
                    isInAnimation: false,
                });
                if (currentIndex >= _this.itemLength) {
                    _this.setState({
                        currentIndex: 0,
                    });
                    return;
                }
                if (currentIndex < 0) {
                    _this.setState({
                        currentIndex: _this.itemLength - 1,
                    });
                    return;
                }
                (_b = (_a = _this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, _this.getWrappedIndex(currentIndex), _this.lastSource);
            }, (_a = this.props.duration) !== null && _a !== void 0 ? _a : 500 + Swiper.EXTRA_TIME);
        }
    };
    Swiper.prototype.componentWillUnmount = function () {
        this.setState = function () { return false; };
    };
    Swiper.prototype.getSwipeAnimationStyle = function (styleProps) {
        var renderLength = styleProps.renderLength, currentIndex = styleProps.currentIndex, needAnimation = styleProps.needAnimation, duration = styleProps.duration, hasExtraFront = styleProps.hasExtraFront, animationStyle = styleProps.animationStyle;
        return {
            width: renderLength + "00%",
            height: '100%',
            transform: "translate3d(-" + (currentIndex + (hasExtraFront ? 1 : 0)) * 100 / renderLength + "%, 0, 0px)",
            transition: needAnimation ? "transform " + duration / 1000 + "s " + animationStyle : '',
        };
    };
    Swiper.prototype.renderNavigation = function () {
        var _a = this.props, loop = _a.loop, showNav = _a.showNav;
        var _b = this.state, currentIndex = _b.currentIndex, isShowNav = _b.isShowNav, isShowArrow = _b.isShowArrow;
        if (showNav === 'never' || !isShowNav) {
            return null;
        }
        return h(Navigation, { renderLeftArrow: !(!loop && currentIndex === 0) && isShowArrow, renderRightArrow: !(!loop && currentIndex === this.itemLength - 1) && isShowArrow, navCount: this.itemLength, currentIndex: currentIndex, onNavMouseAction: this.onNavMouseAction, onClickArrow: this.onClickArrow, navigationDotsStyle: {
                width: this.itemLength * 14 + "px",
                height: '12px',
            } });
    };
    Swiper.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    Swiper.EXTRA_TIME = 50;
    return Swiper;
}(React.Component));
export default Swiper;
Swiper.defaultProps = {
    prefixCls: 'dui-swiper',
    autoplay: true,
    interval: 3000,
    duration: 500,
    stopOnHover: true,
    showArrow: 'hover',
    showNav: 'hover',
    navTrigger: 'click',
    loop: true,
};
